import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ApolloProvider } from '@apollo/client';
import { Toaster } from 'react-hot-toast';
import Layout from './components/Layout';
import { apolloClient } from './graphql/client';
import Dashboard from './pages/Dashboard';
import OffersWizard from './pages/OffersWizard';
import OffersManagement from './pages/OffersManagement';
import ProductsManagement from './pages/ProductsManagement';
import MerchantsManagement from './pages/MerchantsManagement';
import CitiesManagement from './pages/CitiesManagement';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import ApiTest from './pages/ApiTest';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import ErrorBoundary from './components/ErrorBoundary';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
    },
  },
});

function App() {
  return (
    <ErrorBoundary>
      <ApolloProvider client={apolloClient}>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <NotificationProvider>
          <Router>
            <div className="min-h-screen bg-gray-50" dir="rtl">
              <Routes>
                <Route path="/" element={<Layout />}>
                  <Route index element={<Dashboard />} />
                  <Route path="offers">
                    <Route index element={<OffersManagement />} />
                    <Route path="new" element={<OffersWizard />} />
                    <Route path=":id/edit" element={<OffersWizard />} />
                  </Route>
                  <Route path="products" element={<ProductsManagement />} />
                  <Route path="merchants" element={<MerchantsManagement />} />
                  <Route path="cities" element={<CitiesManagement />} />
                  <Route path="analytics" element={<Analytics />} />
                  <Route path="settings" element={<Settings />} />
                  <Route path="api-test" element={<ApiTest />} />
                  <Route path="api-test" element={<ApiTest />} />
                </Route>
              </Routes>
              <Toaster
                position="top-left"
                toastOptions={{
                  className: 'toast',
                  duration: 4000,
                  style: {
                    background: 'white',
                    color: '#374151',
                    padding: '12px 16px',
                    borderRadius: '8px',
                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
                  },
                }}
              />
            </div>
          </Router>
            </NotificationProvider>
          </AuthProvider>
        </QueryClientProvider>
      </ApolloProvider>
    </ErrorBoundary>
  );
}

export default App;